
import { DisplayAds } from '../DisplayAds';

export class DisplayAdsPartner extends DisplayAds {

  constructor(props) {
    super(props, { pageForOrgType: 'PARTNER' })
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/DisplayAdsPartner.js